import axios from 'common/utils/axios';
import { ObjectivesViewEnum } from './objectives.constants';
import {
  AddObjectiveCommentRequest,
  CreateObjectiveRequest,
  SetObjectiveStatusRequest,
} from './types/objective.type';

const objectivesApi = axios('objectives');

export const createObjectiveApi = (data: CreateObjectiveRequest) => {
  return objectivesApi.post('', data);
};

export const updateObjectiveApi = (id: string, data: CreateObjectiveRequest) => {
  return objectivesApi.put(`/${id}`, data);
};

export const getAllObjectivesApi = () => {
  return objectivesApi.get('');
};

export const getOrganizationObjectivesApi = () => {
  return objectivesApi.get('/organization-objectives');
};

export const getTeamObjectivesApi = () => {
  return objectivesApi.get('/team-objectives');
};

export const getReporteesObjectivesApi = () => {
  return objectivesApi.get('/reportees-objectives');
};

export const getObjectiveAttentionItemsApi = () => {
  return objectivesApi.get('/attention-items');
};

export const getContributingGoalsApi = (view: ObjectivesViewEnum) => {
  return objectivesApi.get('/contributing-goals', { params: { view } });
};

export const getObjectiveApi = (id: string) => {
  return objectivesApi.get(`/${id}`);
};

export const getParentObjectiveOptionsApi = () => {
  return objectivesApi.get('/parent-options');
};

export const getCategoryEligibilityApi = () => {
  return objectivesApi.get('/category-eligibility');
};

export const setObjectiveStatusApi = (data: SetObjectiveStatusRequest) => {
  return objectivesApi.post('/set-status', data);
};

export const getObjectiveActivityApi = (objectiveId: string) => {
  return objectivesApi.get(`/${objectiveId}/objective-activity`);
};

export const addObjectiveCommentApi = ({
  objectiveId,
  comment,
}: AddObjectiveCommentRequest) => {
  return objectivesApi.post(`/${objectiveId}/comments`, { comment });
};
